import { BaseText, Headline1, theme } from 'aimo-ui';
import SvgImage from 'components/svgImage/SvgImage';
import React from 'react';
import styled from 'styled-components/native';
import { StyledWrapper } from 'styles/ContainerStyles';
import { Maybe } from 'types/generatedSchemaTypes';

interface PermitTicketHeaderProps {
  title: string;
  subtitle?: string;
  details?: Maybe<string>;
  testID?: string;
  usePinIcon?: boolean;
  boldSubtitle?: boolean;
  subDetails?: Maybe<string>;
  additionalTitle?: Maybe<string>;
}

const SubtitleText = styled(BaseText)<{ bold?: boolean }>`
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  padding-top: ${theme.normalising.heightPixel(20)}px;
  text-align: center;
`;

const DetailsText = styled(BaseText)`
  padding-top: ${theme.normalising.heightPixel(10)}px;
  text-align: center;
`;

const SubDetailsText = styled(BaseText)`
  padding-top: ${theme.normalising.heightPixel(20)}px;
  text-align: center;
`;

const PermitTicketHeader: React.FC<PermitTicketHeaderProps> = ({
  title,
  subtitle,
  details,
  testID,
  usePinIcon,
  boldSubtitle,
  subDetails,
  additionalTitle,
}) => {
  return (
    <>
      <StyledWrapper mb={theme.normalising.heightPixel(25)}>
        <SvgImage
          name={usePinIcon ? 'Pin' : 'Permit'}
          width={usePinIcon ? 100 : 124}
          height={usePinIcon ? 90 : 120}
          testID={`${testID}-image`}
        />
      </StyledWrapper>
      <StyledWrapper
        center
        mb={theme.normalising.heightPixel(10)}
        mr={theme.normalising.widthPixel(30)}
        ml={theme.normalising.widthPixel(30)}>
        <Headline1 center testID={`${testID}-title`}>
          {title}
        </Headline1>
        {additionalTitle && (
          <SubtitleText
            bold={boldSubtitle}
            testID={`${testID}-additional-title`}>
            {additionalTitle}
          </SubtitleText>
        )}
        {subtitle && (
          <SubtitleText bold={boldSubtitle} testID={`${testID}-info`}>
            {subtitle}
          </SubtitleText>
        )}
        {details && (
          <DetailsText testID={`${testID}-details`}>{details}</DetailsText>
        )}
        {subDetails && (
          <SubDetailsText testID={`${testID}-details`}>
            {subDetails}
          </SubDetailsText>
        )}
      </StyledWrapper>
    </>
  );
};

export default PermitTicketHeader;
